import { jsx as _jsx } from "react/jsx-runtime";
import Plotly from "plotly.js-dist-min";
import React, { useEffect, useRef } from "react";
export const DonutChart = ({ colors, customText, height = 280, innerRadius = 0.4, labels, margin = 20, showLegend = false, sort = true, values, width = 280 }) => {
    const chartRef = useRef(null);
    const data = [
        {
            hole: innerRadius,
            hovertemplate: customText
                ? "<b>%{label}</b><br>%{text}<br><extra></extra>"
                : "<b>%{label}</b><br>%{value}%<br><extra></extra>",
            labels,
            marker: {
                colors,
                line: {
                    color: "#ffffff",
                    width: 2
                }
            },
            sort,
            text: customText,
            textinfo: "none",
            type: "pie",
            values
        }
    ];
    const layout = {
        height,
        margin: { b: margin, l: margin, r: margin, t: margin },
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        showlegend: showLegend,
        width
    };
    const config = {
        displayModeBar: false,
        responsive: true,
        staticPlot: false
    };
    useEffect(() => {
        if (chartRef.current) {
            Plotly.newPlot(chartRef.current, data, layout, config);
        }
    }, [colors, customText, height, innerRadius, labels, margin, showLegend, sort, values, width]);
    return _jsx("div", { className: "donut-chart-container w-full h-full", "data-testid": "donut-chart", ref: chartRef });
};
export default DonutChart;
